<template>
  <b-modal
    ref="modalConfirm"
    body-class="p-1"
    hide-header
    hide-footer
    centered
    no-close-on-backdrop
    no-close-on-esc
  >
    <div class="modal-confirm d-flex flex-column justify-content-center">
      <b-row class="justify-content-center mb-1 pt-1">
        <b-img
          :src="iconUrl"
          width="100"
          height="100"
        />
      </b-row>
      <b-row class="text-center px-4 justify-content-center mt-[16px] mb-[8px]">
        <p class="text-xl font-bold text-black mb-[8px]">
          {{ options.title }}
        </p>
        <p class="text-black">
          {{ options.description }}
        </p>
      </b-row>
      <div
        v-if="options.type === 'confirm'"
        class="d-flex gap-2"
      >
        <b-button
          variant="outline-primary"
          class="w-full"
          @click="close"
        >
          Batal
        </b-button>
        <b-button
          variant="primary"
          class="w-full"
          :disabled="loading"
          @click="handleConfirm"
        >
          <b-spinner
            v-if="loading"
            small
            class="mr-1"
          />
          {{ options.confirmText || 'Konfirmasi' }}
        </b-button>
      </div>
      <b-button
        v-else
        variant="primary"
        class="w-full"
        @click="handleConfirm"
      >
        Selesai
      </b-button>
    </div>
  </b-modal>
</template>

<script>
import { Button } from '@/@core/components/ui'

export default {
  name: 'ModalConfirm',
  data() {
    return {
      loading: false,
      options: {
        title: '',
        description: '',
        type: 'confirm',
        confirmText: 'Konfirmasi',
        confirmFn: null,
      },
    }
  },
  computed: {
    iconUrl() {
      if (this.options.type === 'success') {
        return 'https://storage.googleapis.com/komerce/core/icon-popup-success.png'
      }
      return 'https://storage.googleapis.com/komerce/core/icon-popup-warning.png'
    },
  },
  methods: {
    /**
     * Show the modal confirm
     * @public exposed to the parent component via $refs
     * @param {Object} opts - The options
     * @param {String} opts.title - The title
     * @param {String} opts.description - The description
     * @param {String} opts.type - The type
     * @param {String} opts.confirmText - The confirm text
     * @param {Function} opts.confirmFn - The confirm function used to handle the confirm button click
     */
    show(opts = {}) {
      this.options = {
        title: opts.title || '',
        description: opts.description || '',
        type: opts.type || 'confirm',
        confirmText: opts.confirmText || 'Konfirmasi',
        confirmFn: opts.confirmFn || null,
      }
      this.loading = false
      this.$refs.modalConfirm.show()
    },
    /**
     * Close the modal confirm
     * @public exposed to the parent component via $refs
     */
    close() {
      this.$refs.modalConfirm.hide()
      this.$emit('on-close')
    },
    /**
     * Handle the confirm button click
     * @public exposed to the parent component via $refs
     */
    async handleConfirm() {
      if (typeof this.options.confirmFn === 'function') {
        this.loading = true
        try {
          await this.options.confirmFn(this.close)
        } finally {
          this.loading = false
        }
      } else {
        this.$emit('on-confirm')
        this.close()
      }
    },
  },
}
</script>

<style scoped>
.modal-confirm {
  width: 100%;
  height: 100%;
  background-color: #fff;
}
</style>
